import React from "react";
import { useTranslation } from "react-i18next";
import InfoIcon from "../common/InfoIcon";

export default function CarryForwardColumnHeader({ className = "" }) {
    const { t } = useTranslation();

    return (
        <th className={className}>
            <span className="inline-flex items-center justify-center gap-1">
                {t("attendance.carryForward")}
                <InfoIcon message={t("attendance.carryForwardColumnHelp")} />
            </span>
        </th>
    );
}
